import {
  Button,
  Drawer,
} from "@material-ui/core";
import React, {  useEffect, useRef, useState } from "react";
import DrawerHeader from "./DrawerHeader";
import { addContactV2Style } from "./AddContactV2Style";
import AddContactSidebar from "./AddContactSidebar";
import PersonalContactInfoTabsItem from "./PersonalContactInfoTabsItem";
import CommercialContactInfoTabsItem from "./CommercialContactInfoTabItem";
import { getContactLimit, getInsuranceCompanyOptions, getUserPolicyOptions } from "../../reducers/addContactOptionReducer/addContactOptionsAction";
import { useDispatch } from "react-redux";
import Utils from "../../helpers/Utils";
import { saveContact } from "../../reducers/addContactOptionReducer/addContactOptionsServices";
import { useHistory } from "react-router-dom";
import { CustomFieldType } from "../addContact/CoreConstants";
import './addContact.css';


export const CONTACT_TYPE = {
PERSONAL: "PERSONAL",
  COMMERCIAL: "COMMERCIAL",
};


const AddContactV3 = ({ open, onClose, data }) => {
  const [contactType, setContactType] = useState(CONTACT_TYPE.PERSONAL);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldsData, setCustomFieldsData] = useState([]);
  const [customFieldsForCommercial, setCustomFieldsForCommercial] = useState([]);
  const [customFieldsDataForCommercial, setCustomFieldsDataForCommercial] = useState([]);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contactForm, setContactForm] = useState({
    selected_source: "",
    lead_type: "",
    first_name: "",
    last_name: "",
    numbers: [{ number: "", number_state: "" }],
    emails: [{ email: "" }],
    related_contacts: [{
      relationship:'',
      first_name: '',
      last_name: '',
      numbers: [{ number: "", number_state: "" }],
      emails: [{ email: "" }],
      birth_date:''
    }],
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    birth_date: "",
    note:'',
    pipeline_id: "",
    stage_id: ""
  });
   const [commercialContactForm, setCommercialContactForm] = useState({
    selected_source: "",
    lead_type: "",
    pipeline_id: "",
    stage_id: "",
    company_name: "",
    dba: "",
    numbers: [{ number: "", number_state: "" }],
    emails: [{ email: "" }],
    primary_contacts: [{
      first_name: '',
      last_name: '',
      numbers: [{ number: "", number_state: "" }],
      emails: [{ email: "" }],
      birth_date:''
    }],
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    note:'',
    type_of_business: "",
    business_classification: "",
    fein: "",
    year_business_started: "",
    years_of_management_experience: "",
    number_of_employees: "",
    annual_revenue: "",
    total_payroll: "",
  });

  const [selectedSection, setSelectedSection] = useState(
    contactType === CONTACT_TYPE.PERSONAL ? "Personal Info" : "Business Info"
  );
  const personalInfoRef = useRef(null);
  const relatedContactsRef = useRef(null);
  const additionalInfoRef = useRef(null);
  const businessInfoRef = useRef(null);
  const primaryContactRef = useRef(null);
  const history = useHistory();
  const classes = addContactV2Style();


  useEffect(() => {
    dispatch(getContactLimit());
    fetchUserCustomFields();
  }, []);

  useEffect(() => {
    setSelectedSection(
      contactType === CONTACT_TYPE.PERSONAL ? "Personal Info" : "Business Info"
    );
  }, [contactType]);

  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionName = entry.target.dataset.section;
            setSelectedSection(sectionName);
          }
        });
      },
      { threshold: 1,
        rootMargin: "0px 0px -400px 0px"
       }
    );

    const observeSections = () => {
      const refs =
        contactType === CONTACT_TYPE.PERSONAL
          ? [personalInfoRef, relatedContactsRef, additionalInfoRef]
          : [businessInfoRef, primaryContactRef, additionalInfoRef];

      refs.forEach((ref) => {
        if (ref.current) {
          observer.observe(ref.current);
        } 
      });
    };

    const timer = setTimeout(() => {
      observeSections();
    }, 0);

    // Cleanup observer
    return () => {
      clearTimeout(timer);
      [
        personalInfoRef,
        relatedContactsRef,
        additionalInfoRef,
        businessInfoRef,
        primaryContactRef,
      ].forEach((ref) => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, [contactType]);

   const fetchUserCustomFields = async () => {
      window
        .globalCustomFieldWithPersonalized({
          get_custom_data: true,
          get_personalized_data: false,
          field_name: ["*"],
          for_drop_down: false,
          drop_down_field: {
            value_field: "id",
            title_field: "title",
          },
        })
        .then(  (res) => {
          let customFieldDatas = res.data.custom_field;
          let customFieldValues = [];
          let hasInsuranceField = false;
          let hasPolicyField = false;
          customFieldDatas.forEach((row, index) => {
            customFieldValues.push(null);

             if (
          row.type_id === CustomFieldType.SELECT &&
          row.personalize_tag === "[[insurance_company]]"
        ) {
          hasInsuranceField = true;
        }

        if (
          row.type_id === CustomFieldType.SELECT &&
          row.personalize_tag === "[[policy_type_(l.o.b)]]"
        ) {
          hasPolicyField = true;
        }
          });
           if(hasInsuranceField) {
           dispatch(getInsuranceCompanyOptions());
        }
         if(hasPolicyField) {
           dispatch(getUserPolicyOptions());
        }
          setCustomFields(customFieldDatas);
          setCustomFieldsData(customFieldValues);
          setCustomFieldsForCommercial(customFieldDatas);
          setCustomFieldsDataForCommercial(customFieldValues);

        });
  };

  const handleClose = () => {
    onClose();
  };
    const handleCustomFieldChange = (
    value,
    index_field,
    id,
    maxLength = null
  ) => {
    if ((maxLength != null) & (value.length > maxLength)) {
      return false;
    }

    let previousData = contactType === CONTACT_TYPE.PERSONAL ?  [...customFieldsData] : [...customFieldsDataForCommercial];
    if (value === "") {
      previousData[index_field] = null;
    } else {
      previousData[index_field] = {
        user_custom_field_id: id,
        value: value,
      };
    }
    if (contactType === CONTACT_TYPE.PERSONAL) {
      setCustomFieldsData(previousData);
    } else {
      setCustomFieldsDataForCommercial(previousData);
    }
  };


const isInvalidEmails = (emailSource) => {
  let hasInvalid = false;
  let invalidEmail = null;

  const validateEmailArray = (emails) => {
    if (!Array.isArray(emails)) return;
    for (let i = 0; i < emails.length; i++) {
      const email = emails[i]?.email?.trim();
      if (email && !Utils.validateEmail(email)) {
        hasInvalid = true;
        if (!invalidEmail) invalidEmail = email;
        break;
      }
    }
  };

  if (Array.isArray(emailSource) && emailSource.length) {
    if (emailSource[0]?.email !== undefined) {
      validateEmailArray(emailSource);
    } else if (emailSource[0]?.emails !== undefined) {
      for (let i = 0; i < emailSource.length; i++) {
        validateEmailArray(emailSource[i]?.emails);
        if (hasInvalid) break;
      }
    }
  }

  return { hasInvalid, invalidEmail };
};

const isInvalidPhoneNumbers = (numberSource) => {
  let hasInvalid = false;
  let invalidNumber = null;

  const validateNumberArray = (numbers) => {
    if (!Array.isArray(numbers)) return;
    for (let i = 0; i < numbers.length; i++) {
      const number = numbers[i]?.number?.trim();
      if (number && !Utils.validateMobileNumber(number)) {
        hasInvalid = true;
        if (!invalidNumber) invalidNumber = number;
        break;
      }
    }
  };

  if (Array.isArray(numberSource) && numberSource.length) {
    if (numberSource[0]?.number !== undefined) {
      validateNumberArray(numberSource);
    } else if (numberSource[0]?.numbers !== undefined) {
      for (let i = 0; i < numberSource.length; i++) {
        validateNumberArray(numberSource[i]?.numbers);
        if (hasInvalid) break;
      }
    }
  }

  return { hasInvalid, invalidNumber };
};

const validateContactForm = (form, contactType) => {
  if (!form.numbers[0]?.number && !form.emails[0]?.email) {
    window.showNotification(
      "Error",
      "Email and Number, Either of them are necessary"
    );
    return false;
  }

  const { hasInvalid: mainHasInvalid, invalidEmail: mainInvalidEmail } =
    isInvalidEmails(form.emails);
  if (mainHasInvalid) {
    window.showNotification("Error", `${mainInvalidEmail} is Invalid Email!`);
    return false;
  }

  const { hasInvalid: mainHasInvalidNum, invalidNumber: mainInvalidNum } =
    isInvalidPhoneNumbers(form.numbers);
  if (mainHasInvalidNum) {
    window.showNotification("Error", `${mainInvalidNum} is Invalid Number!`);
    return false;
  }

  const { hasInvalid, invalidEmail } = isInvalidEmails(
    contactType === CONTACT_TYPE.PERSONAL
      ? form.related_contacts
      : form.primary_contacts
  );
  if (hasInvalid) {
    window.showNotification("Error", `${invalidEmail} is Invalid Email!`);
    return false;
  }

  const { hasInvalid: numberHasInvalid, invalidNumber } = isInvalidPhoneNumbers(
    contactType === CONTACT_TYPE.PERSONAL
      ? form.related_contacts
      : form.primary_contacts
  );
  if (numberHasInvalid) {
    window.showNotification("Error", `${invalidNumber} is Invalid Number!`);
    return false;
  }

  return true;
};


const handleSaveContact = async () => {
  setIsSubmitting(true);
  try {
    const isPersonal = contactType === CONTACT_TYPE.PERSONAL;
    const currentForm = isPersonal ? contactForm : commercialContactForm;
    const customFields = isPersonal ? customFieldsData : customFieldsDataForCommercial;
    const contactTypeStr = isPersonal ? CONTACT_TYPE.PERSONAL : CONTACT_TYPE.COMMERCIAL;

    if (!validateContactForm(currentForm, contactTypeStr)) return;

    const updatedForm = !isPersonal
    ? { ...currentForm, 
      first_name: currentForm.company_name 
    }
    : currentForm;

    const tempContactForm = {
      ...updatedForm,
      custom_fields: customFields,
      contact_type: contactTypeStr,
    };
    const response = await saveContact(tempContactForm);
    if (response.success && response.data?.contact_id) {
       window.showNotification('Success', response.message);
       handleClose();
       if (data?.successCallback){
           data.successCallback(response.data);
       }else {
           history.push('/contacts/' + response.data.contact_id);
       }
    } else {
      window.showNotification('Error', response.message);
    }
  } catch (error) {
    console.error("Error during form submission:", error);
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <div
        role="presentation"
        style={{ backgroundColor: "rgb(246, 247, 251)", width: "900px" }}
      >
        <DrawerHeader
          contactType={contactType}
          setContactType={setContactType}
        />

        <div style={{ display: "flex" }}>
         <AddContactSidebar
           contactType={contactType}
           selectedSection={selectedSection}
           setSelectedSection={setSelectedSection}
           personalInfoRef={personalInfoRef}
           relatedContactsRef={relatedContactsRef}
           businessInfoRef={businessInfoRef}
           primaryContactRef={primaryContactRef}
           additionalInfoRef={additionalInfoRef} 
          />

          {contactType === CONTACT_TYPE.PERSONAL ? (
            <PersonalContactInfoTabsItem
              personalInfoRef={personalInfoRef}
              contactForm={contactForm}
              setContactForm={setContactForm}
              relatedContactsRef={relatedContactsRef}
              additionalInfoRef={additionalInfoRef}
              customFields={customFields}
              customFieldsData={customFieldsData}
              handleCustomFieldChange={handleCustomFieldChange}
          />
          ) : (
            <CommercialContactInfoTabsItem
              personalInfoRef = {personalInfoRef}
              primaryContactRef={primaryContactRef}
              businessInfoRef={businessInfoRef}
              additionalInfoRef={additionalInfoRef}
              commercialContactForm={commercialContactForm}
              setCommercialContactForm={setCommercialContactForm}
              customFields={customFieldsForCommercial}
              customFieldsData={customFieldsDataForCommercial}
              handleCustomFieldChange={handleCustomFieldChange}
            />
          )}
        </div>

        <div style={{ display: "flex", borderTop: "2px solid rgb(229, 232, 239)" , paddingTop: "10px",  }}>
          {/* <div className={classes.sidebarWrapper}>
            <div
              style={{
                width: "100%",
                paddingInline: "16px",
                display: "flex",
                justifyContent: "flex-start",
                gap: "8px",
                color: "#3C7EF3",
                cursor: "pointer",
              }}
            >
              <OpenInNewIcon style={{color: "#3C7EF3"}} /> Edit This Form
            </div>
          </div> */}

          <div
            style={{
              width: "100%",
              paddingInline: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "16px",
            }}
          >
            <Button
              variant="outlined"
              className={classes.cancelButton}
              disableElevation
              onClick={handleClose}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              className={classes.submitButton}
              disableElevation
              onClick={handleSaveContact}
              disabled={isSubmitting}
            >
             {isSubmitting ? "Saving..." : "Save & Exit"}
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default AddContactV3;
